import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useLocation, useHistory } from "react-router-dom";
import {
  getDataObject,
  // mrStatementGroupInfo,
  mrStatementDataObject,
  mrStatementValidate,
  mrStatementTableHeader,
  mrStatementTableItems,
} from "../config/biltyReport.js";
import { useRef, useState, useEffect , useMemo} from "react";
let ex_data = [];
let ex_data2 = [];

function BiltyReport({ sessionObject }) {
    const history = useHistory();
    const location = useLocation();

  const guruColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Billing Party",
        accessor: "billing_party_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "invoice_no",
        canFilter: true,
      },
      {
        Header: "Invoice No",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Item",
        accessor: "item_name",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Charge Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Actual Weight",
        accessor: "actual_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD Charge",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "LC Charge",
        accessor: "lc_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Other Amount",
        accessor: "other_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "PF",
        accessor: "pf",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );
  const gdalaColumns = React.useMemo(
    () => [
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );
  const avrColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Paid Due Name",
        accessor: "paid_due_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Vasuli Memo",
        accessor: "booking_chalan_no",
        canFilter: true,
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const bbacColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "90px",
        minWidth: "90px",
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Paid Due Name",
        accessor: "paid_due_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Balance",
        accessor: "balance",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Crossing Charge",
        accessor: "crossing_charge",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "70px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "90px",
        minWidth: "90px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const nptcColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Paid Due Name",
        accessor: "paid_due_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const shubhamColums = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );
  const nrabColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );
  const chamundaColums = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Billing Party",
        accessor: "billing_party_name",
        canFilter: true,
      },
      {
        Header: "Truck No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Second Consignor Name",
        accessor: "second_consignor_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      // {
      //   Header: "Second Consignor GST",
      //   accessor: "second_consignor_gst",
      //   canFilter: true,
      //   width: "70px",
      //   minWidth: "50px",
      // },
      {
        Header: "Second Consignee Name",
        accessor: "second_consignee_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      {
        Header: "Third Consignor Name",
        accessor: "third_consignor_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      {
        Header: "Third Consignee Name",
        accessor: "third_consignee_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      // {
      //   Header: "Third Consignor GST",
      //   accessor: "third_consignor_gst",
      //   canFilter: true,
      //   width: "70px",
      //   minWidth: "50px",
      // },
      {
        Header: "PR No.",
        accessor: "pr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Second PR No.",
        accessor: "pr_no1",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "LOT No.",
        accessor: "lot_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Second LOT No.",
        accessor: "lot_no1",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "PO No.",
        accessor: "po_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Detention",
        accessor: "detention",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Loading charge",
        accessor: "loading_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Unloading charge",
        accessor: "unloading_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "RTO",
        accessor: "rto",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Advance",
        accessor: "advance",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );
  const sraColumns = React.useMemo(
    () => [
      {
        Header: "MR No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "MR Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "LR No",
        accessor: "lr_no",
        canFilter: true,
      },
      {
        Header: "Booking LR Date",
        accessor: "booking_lr_date",
        canFilter: true,
      },
      {
        Header: "TBB/Paid Memo No",
        accessor: "paid_tbb_memo_no",
        canFilter: true,
      },
      {
        Header: "MR Type",
        accessor: "mr_type",
        canFilter: true,
      },
      {
        Header: "Billing Party",
        accessor: "billing_party",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Handling Charge",
        accessor: "bilty_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Unloading Charge",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );
  const vihiraColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Transporter Name",
        accessor: "transporter_name",
        canFilter: true,
      },
      {
        Header: "Loaded By",
        accessor: "loaded_by",
        canFilter: true,
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const gtransColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
     
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
     
    ],
    []
  );

  const bgtcColumns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        id: "sr_no",
        Cell: ({ row }) => row.index + 1,
        width: "60px",
        minWidth: "60px",
        canFilter: false,
      },

      {
        Header: "Suffix",
        accessor: "suffix",
        width: "60px",
        minWidth: "60px",
        canFilter: true,
      },

      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },

      {
        Header: "Ref No",
        accessor: "reference_no",
        canFilter: true,
        width: "90px",
        minWidth: "70px",
      },

      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        canFilter: true,
      },

      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },

      {
        Header: "Billing Party",
        accessor: "billing_party_name",
        canFilter: true,
      },

      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },

      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "Package",
        accessor: "no_of_package",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Private Marka No",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Item Name",
        accessor: "item_name",
        canFilter: true,
      },

      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
        Cell: ({ row, value }) => {
          const roleId = sessionObject?.sessionVariables?.role_id;
          const payType = row.original?.pay_type;

          if (
            process.env.REACT_APP_CLIENT === "bgtc" &&
            row.original &&
            (payType === 4) &&
            ![1, 2].includes(roleId)
          ) {
            return "-";
          }

          return value ?? "";
        },
      },
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },

      {
        Header: "Challan Inward No",
        accessor: "is_inwarded",
        canFilter: true,
        width: "100px",
        minWidth: "80px",
      },

      {
        Header: "Local Deli No",
        accessor: "local_delivery_no",
        canFilter: true,
        width: "100px",
        minWidth: "80px",
      },

      {
        Header: "Local Deli Date",
        accessor: "local_delivery_date",
        canFilter: true,
        Cell: ({ value }) => {
          if (!value) return "";
          return value.split("T")[0];
        },
        width: "120px",
        minWidth: "120px",
      },
      {
        Header: "MR No",
        accessor: "mr_no",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },

      {
        Header: "MR Date",
        accessor: "mr_date",
        width: "120px",
        minWidth: "120px",
        canFilter: true,
      },

      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const bgtcColumnsForAdminInward = React.useMemo(
    () => [
      {
        Header: "Sr No",
        id: "sr_no",
        Cell: ({ row }) => row.index + 1,
        width: "60px",
        minWidth: "60px",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Ref No",
        accessor: "reference_no",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Billing Party Name",
        accessor: "billing_party_name",
        width: "120px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Package",
        accessor: "no_of_package",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Weight",
        accessor: "weight",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Item Name",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Freight",
        accessor: "freight",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "DD Charge",
        accessor: "door_del_charge",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Collection Charge",
        accessor: "lc_charge",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "PF",
        accessor: "other_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan Inward",
        accessor: "is_inwarded",
        canFilter: true,
      },
      {
        Header: "Local Deli No",
        accessor: "local_delivery_no",
        canFilter: true,
      },
      {
        Header: "Local Deli Date",
        accessor: "local_delivery_date",
        canFilter: true,
        Cell: ({ value }) => {
          if (!value) return "";
          return value.split("T")[0];
        },
        width: "120px",
        minWidth: "120px",
      },
      {
        Header: "Tempo Collection",
        accessor: "tempo_collection",
        canFilter: true,
      },
      {
        Header: "MR No",
        accessor: "mr_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "MR Date",
        accessor: "mr_date",
        width: "80px",
        minWidth: "60px",
        canFilter: true,
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const defaultColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no",
        canFilter: true,
      },
      {
        Header: "Packages",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        canFilter: true,
      },
      {
        Header: "DD",
        accessor: "dd_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Inward Date",
        accessor: "inward_date",
        width: "120px",
        minWidth: "120px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Second Consignor Name",
        accessor: "second_consignor_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      // {
      //   Header: "Second Consignor GST",
      //   accessor: "second_consignor_gst",
      //   canFilter: true,
      //   width: "70px",
      //   minWidth: "50px",
      // },
      {
        Header: "Second Consignee Name",
        accessor: "second_consignee_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      {
        Header: "Third Consignor Name",
        accessor: "third_consignor_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      {
        Header: "Third Consignee Name",
        accessor: "third_consignee_name",
        canFilter: true,
        width: "130px",
        minWidth: "50px",
      },
      // {
      //   Header: "Third Consignor GST",
      //   accessor: "third_consignor_gst",
      //   canFilter: true,
      //   width: "70px",
      //   minWidth: "50px",
      // },
      {
        Header: "PR No.",
        accessor: "pr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "LOT No.",
        accessor: "lot_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "PO No.",
        accessor: "po_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );
  
  // We'll start our table without any data
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  const download_ref = React.useRef(null);

  const sortIdRef = React.useRef(0);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    in_stock: "1",
    pending_bill: "2",
    own_branch : "1",
    dd_charge:"2",
    hamali_charge:"2",
    pending_mr: "",
    bilty_from: "",
    bilty_to: "",
  });

  const [pageState, setPageState] = React.useState({
    total_dd_charge: 0,
    total_lc_charge: 0,
    total_hamali: 0,
    total_other_amount:0,
    total_freight: 0,
    total_amount: 0,
    total_weight: 0,
    total_pkgs: 0,
    total_pf: 0,
    total_bilties:0,
  });
  const [finalInput, setFinalInput] = React.useState({});

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reportType =
      params.get("report_type") ||
      (location.pathname === "/delete-bilty-report" ? "deleted" : null);

    if (reportType && reportType !== dateState.report_type) {
      setDateState(prev => ({
        ...prev,
        report_type: reportType,
      }));
    }
  }, [location.search, location.pathname]);

  const isDeletedReport =
    dateState.report_type === "deleted" ||
    location.pathname === "/delete-bilty-report";

  const getColumnsBasedOnClient = ()=> {
    if (process.env.REACT_APP_CLIENT == "gdala_log"){
      return gdalaColumns
    }
    else if (
      process.env.REACT_APP_CLIENT == "avr" || 
      process.env.REACT_APP_CLIENT == "jtsa" || 
      process.env.REACT_APP_CLIENT == "bvtc" || 
      process.env.REACT_APP_CLIENT == "std"
    ) {
      return avrColumns;
    }
    else if (process.env.REACT_APP_CLIENT == "bbac") {
      return bbacColumns;
    }
    else if (
      process.env.REACT_APP_CLIENT == "arbuda"
    ) {
      return avrColumns;
    }
    else if (process.env.REACT_APP_CLIENT == "nptc"){
      return nptcColumns
    }
    else if (process.env.REACT_APP_CLIENT == "vihira"){
      return vihiraColumns
    }
    else if (process.env.REACT_APP_CLIENT == "sra"){
      return sraColumns
    }
    else if (process.env.REACT_APP_CLIENT == "shubham"){
      return shubhamColums
    }
    else if (process.env.REACT_APP_CLIENT == "nrab"){
      return nrabColumns
    }
    else if (process.env.REACT_APP_CLIENT == "guru"){
      return guruColumns
    }
    else if (process.env.REACT_APP_CLIENT == "g_trans"){
      return gtransColumns
    }
    else if (process.env.REACT_APP_CLIENT == "xpress"){
      return chamundaColums
    }
    else if (process.env.REACT_APP_CLIENT === "bgtc") {
      if (dateState.report_type === "admin-inward") {
        return bgtcColumnsForAdminInward;
      }
      return bgtcColumns;
    }
    else {
      return defaultColumns
    }
  }

  var columns = getColumnsBasedOnClient()

  if (isDeletedReport) {
    columns = [
      ...columns,
      {
        Header: "Deleted By",
        accessor: "deleted_by",
        canFilter: true,
      },
      {
        Header: "Deleted Date",
        accessor: "deleted_date",
        width: "120px",
        minWidth: "120px",
        canFilter: false,
      },
    ];
  }

//   React.useEffect(() => {
//       console.log(dateState);
//   })

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      console.log("12323", sortBy, customFilters, fetchId);
      for (let key in customFilters){
        console.log("Key", key)
        if (customFilters[key]== null){
          continue
        }
        if (customFilters[key].toLowerCase() == "none"){
          customFilters[key] = null
        }
      }
      // Set the loading state
      setLoading(true);

      if (fetchId === fetchIdRef.current) {
        console.log("Date state", dateObject);


        let newObject = {}

        if (dateObject.report_type == "deleted") {
          newObject.created_from = String(
            sessionObject.sessionVariables.branch_id
          );
        }
        
        if(process.env.REACT_APP_CLIENT == "gdala_log") {
          if (dateObject.in_stock !== "1") {
            newObject.in_stock = 1
          }
        }

        if (dateObject.report_type == "bilty"){         
          if (dateObject.in_stock == "1") {
            newObject.created_from = String(
                sessionObject.sessionVariables.branch_id
            );
          }
          else {
            newObject.mr_no = null
            newObject.crossing_outward = null; 
            newObject.created_from = String(
                sessionObject.sessionVariables.branch_id
            );
            newObject.owned_by = String(
              sessionObject.sessionVariables.branch_id
            );
            // newObject.crossing_outward = null;
          }
          if (dateObject.pending_bill == "1") {
            newObject.pending_bill = String(
              1
            );
          } 
          if(dateObject.dd_charge == "1"){
            newObject.dd_charge = String(1);
          }
          if(dateObject.hamali_charge == "1"){
            newObject.hamali_charge = String(1);
          }
        }

        if (dateObject.report_type == "inward"){
            newObject.not_created_from = String(
                sessionObject.sessionVariables.branch_id
            );
            newObject.owned_by = String(
                sessionObject.sessionVariables.branch_id
            );

          if (dateObject.own_branch == "2") {
            newObject.not_station_to = String(
              sessionObject.sessionVariables.branch_id
            );
          }

          if (dateObject.in_stock == "2") {
            newObject.mr_no = null
            newObject.crossing_outward = null; 
            newObject.currently_owned_by  = String(
                sessionObject.sessionVariables.branch_id
            );
          }
        }

        if (dateObject.report_type == "admin-inward"){
            // newObject.not_created_from = String(
            //     sessionObject.sessionVariables.branch_id
            // );
            // newObject.owned_by = String(
            //     sessionObject.sessionVariables.branch_id
            // );

          if (dateObject.own_branch == "2") {
            newObject.not_station_to = String(
              sessionObject.sessionVariables.branch_id
            );
          }

          if (dateObject.in_stock == "2") {
            newObject.mr_no = null
            newObject.crossing_outward = null; 
            newObject.currently_owned_by  = String(
                sessionObject.sessionVariables.branch_id
            );
          }
        }

        if (
          process.env.REACT_APP_CLIENT === "bgtc" &&
          dateObject.pending_mr === "1"
        ) {
          newObject.pending_mr = "1";
        }

        newObject = {...newObject,...customFilters}

        if (process.env.REACT_APP_CLIENT === "nrab") {
          delete newObject.dd_charge;
          delete newObject.hamali_charge;

          if (dateObject.dd_charge === "1") {
            newObject.dd_charge = "1";
          } else if (dateObject.hamali_charge === "1") {
            newObject.hamali_charge = "1";
          }
        }

        if (process.env.REACT_APP_CLIENT === "bgtc") {
            if (dateObject.bilty_from)
              newObject.bilty_from = dateObject.bilty_from;

            if (dateObject.bilty_to)
              newObject.bilty_to = dateObject.bilty_to;
          }

          if (
            process.env.REACT_APP_CLIENT === "bgtc" &&
            (dateObject.bilty_from || dateObject.bilty_to)
          ) {
            const fyString = JSON.parse(
              sessionStorage.getItem("financial_year_for_fetch")
            )?.financial_year_for_fetch;

            if (fyString) {
              const startYY = fyString.split("-")[0];
              const fyStartYear = 2000 + Number(startYY);

              dateObject.date_from = new Date(
                `${fyStartYear}-04-01T00:00:00.000Z`
              );
            }
          }

        let inputData = {
          paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
          sort_fields: sortBy,
          filter_fields: newObject,
          date_dict: {
            date_from: dateObject.date_from,
            date_to: dateObject.date_to,
          },
        };

        setFinalInput(inputData);

        let url = SERVER_URL + "/report/";

        if (dateObject.report_type == "deleted") {
            url += "deleted/";
        } else if (dateObject.report_type == "inward" || dateObject.report_type == "admin-inward") {
            url += "inward/";
        }

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(inputData),
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          const resp = await response.json();
  
          let setObj = {};
          if (fetchId === fetchIdRef.current) {
            if (resp["data"] && "total_rows" in resp) {
              setData(resp["data"]);
              setPageCount(Math.ceil(resp["total_rows"] / pageSize));
  
              setObj = {
                total_dd_charge: resp["total_dd_charge"],
                total_lc_charge: resp["total_lc_charge"],
                total_hamali: resp["total_hamali"],
                total_other_amount: resp["total_other_amount"],
                total_freight: resp["total_freight"],
                total_amount: resp["total_amount"],
                total_weight: resp["total_weight"],
                total_pkgs:
                  ["bgtc"].includes(process.env.REACT_APP_CLIENT)
                    ? resp.total_no_of_pkgs
                    : resp.total_pkgs,
                total_pf: resp["total_pf"],
                total_bilties: resp["total_rows"],
                total_crossing_charge: resp["crossing_charge"],
              };
  
              setPageState({ ...pageState, ...setObj });
            }
  
            setLoading(false);
          }
        } catch (error) {
          console.log("Error fetching report data:", error);
          setLoading(false);
        }

      }
      // We'll even set a delay to simulate a server here
      //   setTimeout(() => {
      //     // Only update the data if this is the latest fetch
      //     if (fetchId === fetchIdRef.current) {
      //       const startRow = pageSize * pageIndex;
      //       const endRow = startRow + pageSize;
      //     //   setData(serverData.slice(startRow, endRow));
      //       console.log("data", data);
      //       // Your server could send back total page count.
      //       // For now we'll just fake it, too
      //       setPageCount(Math.ceil(serverData.length / pageSize));
      //
      //       setLoading(false);
      //     }
      //   }, 1000);
    },
    []
  );

  const fetchDataDebounced = useMemo(
    () => _.debounce(fetchData, 500),
    []
  );

  const getTitleName = () => {
    if (dateState.report_type == "bilty") {
      if(process.env.REACT_APP_CLIENT == "sra") {
        return "MR Report";
      } else {
        return "Bilty Report";
      }
    }
    else if (dateState.report_type == "deleted") {
      return "Delete Bilty Report";
    }
    else if (dateState.report_type == "inward") {
      return "Inward Report";
    }
    else if(dateState.report_type == "admin-inward") {
        return "Admin Inward Report";
    }
  };

  const handleViewClick = (cell) => {
    let biltyNo;
    let suffix;

    if (process.env.REACT_APP_CLIENT === "gdala_log") {
      biltyNo = cell[1]?.value;
      suffix = cell[2]?.value;
    } else if (process.env.REACT_APP_CLIENT === "bgtc") {
      biltyNo = cell[2]?.value;
      suffix = cell[1]?.value;
    } else {
      biltyNo = cell[0]?.value;
      suffix = cell[1]?.value;
    }

    if (!biltyNo) return;

    history.push("/bilty", { biltyNo, suffix });
  };

  return (
    <div className="report-bilty">
      <div className="form-header">{getTitleName()}</div>
      <div className="report-bilty-table-container">
        <div className="report-field-row ">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          <div>
            To Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_to}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_to"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          {process.env.REACT_APP_CLIENT !== "sra" && <div>
            <label>Stock?</label>
            <select
              onChange={(e) => {
                const { name, value } = e.target;
                setDateState({
                  ...dateState,
                  [name]: value,
                });
              }}
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
              // disabled={checkDisabledCondition({ name: "is_crossing" })}
              value={dateState["in_stock"]}
              name="in_stock"
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     a.preventDefault();
              //     if (
              //       myForm.pageState.is_crossing == "N" ||
              //       myForm.pageState.is_crossing == "n"
              //     ) {
              //       myForm.makeFocusOnParticularField("bilty_no");
              //       return;
              //     } else {
              //       myForm.makeFocusOnParticularField("transporter_name");
              //       return;
              //     }
              //   }
              // }}
            >
              <option value="1" key="1">
                All
              </option>
              <option value="2" key="2">
                In Stock
              </option>
            </select>
          </div>}
          {
            process.env.REACT_APP_CLIENT !== "sra" && dateState["report_type"] == "bilty" && (
              <div>
                <label>Pending Bill?</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      [name]: value,
                    });
                  }}
                  // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                  // disabled={checkDisabledCondition({ name: "is_crossing" })}
                  value={dateState["pending_bill"]}
                  name="pending_bill"
                  // onKeyPress={(a) => {
                  //   if (a.key == "Enter") {
                  //     a.preventDefault();
                  //     if (
                  //       myForm.pageState.is_crossing == "N" ||
                  //       myForm.pageState.is_crossing == "n"
                  //     ) {
                  //       myForm.makeFocusOnParticularField("bilty_no");
                  //       return;
                  //     } else {
                  //       myForm.makeFocusOnParticularField("transporter_name");
                  //       return;
                  //     }
                  //   }
                  // }}
                >
                  <option value="1" key="1">
                    Yes
                  </option>
                  <option value="2" key="2">
                    No
                  </option>
                </select>
              </div>
            )
          }

          {
            process.env.REACT_APP_CLIENT === "bgtc" &&
            dateState["report_type"] === "bilty" && (
              <div>
                <label>Pending MR?</label>
                <select
                  name="pending_mr"
                  value={dateState.pending_mr}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      [name]: value,
                    });
                  }}
                >
                  <option value="">All</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            )
          }

          {
            process.env.REACT_APP_CLIENT == "nrab" && (
              <div>
                <label>DD Charge</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      dd_charge: value,
                      hamali_charge: value === "1" ? "2" : dateState.hamali_charge,
                    });
                  }}
                  value={dateState["dd_charge"]}
                  name="dd_charge"
                >
                  <option value="1" key="1">
                    Yes
                  </option>
                  <option value="2" key="2">
                    No
                  </option>
                </select>
              </div>
            )
          }
          {
            process.env.REACT_APP_CLIENT == "nrab" && (
              <div>
                <label>Hamali</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      hamali_charge: value,
                      dd_charge: value === "1" ? "2" : dateState.dd_charge,
                    });
                  }}
                  value={dateState["hamali_charge"]}
                  name="hamali_charge"
                >
                  <option value="1" key="1">
                    Yes
                  </option>
                  <option value="2" key="2">
                    No
                  </option>
                </select>
              </div>
            )
          }
          {
            (dateState["report_type"] == "inward" || dateState["report_type"] == "admin-inward") && (
              <div>
                <label>Own Branch?</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      [name]: value,
                    });
                  }}
                  // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                  // disabled={checkDisabledCondition({ name: "is_crossing" })}
                  // disabled={true}
                  value={dateState["own_branch"]}
                  name="own_branch"
                  // onKeyPress={(a) => {
                  //   if (a.key == "Enter") {
                  //     a.preventDefault();
                  //     if (
                  //       myForm.pageState.is_crossing == "N" ||
                  //       myForm.pageState.is_crossing == "n"
                  //     ) {
                  //       myForm.makeFocusOnParticularField("bilty_no");
                  //       return;
                  //     } else {
                  //       myForm.makeFocusOnParticularField("transporter_name");
                  //       return;
                  //     }
                  //   }
                  // }}
                >
                  <option value="1" key="1">
                    Own
                  </option>
                  <option value="2" key="2">
                    Other
                  </option>
                </select>
              </div>
            )
          }

        </div>
        {/* process.env.REACT_APP_CLIENT_NAME == "GDALABHAI LOGISTICS" &&  */}

        {process.env.REACT_APP_CLIENT === "bgtc" && (
          <div className="report-field-row" style={{ marginTop: "10px" }}>
            <div>
              <label style={{ marginRight: "5px" }}>From Bilty No:</label>
              <input
                type="text"
                name="bilty_from"
                value={dateState.bilty_from}
                onChange={(e) =>
                  setDateState({ ...dateState, bilty_from: e.target.value })
                }
              />
            </div>

            <div>
              <label style={{ marginRight: "5px" }}>To Bilty No:</label>
              <input
                type="text"
                name="bilty_to"
                value={dateState.bilty_to}
                onChange={(e) =>
                  setDateState({ ...dateState, bilty_to: e.target.value })
                }
              />
            </div>
          </div>
        )}
        
        <div className="chform-row">
  {
    getDataObject["group-1"].map(function (info) {
      return (
        <div className={info["className"]} key={info["name"]}>
          <label className={info["labelClassName"]}>
            {info["label"]}:
          </label>
          <input
            size="8"
            disabled={true}
            type={info["type"]}
            value={pageState[info["name"]]}
            className={info["inputClassName"]} 
          />
        </div>
      );
    })
  }
</div>

        <ReportTable
          columns={columns}
          data={data}
          fetchData={fetchDataDebounced}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
          canView={true}
          handleViewClick={handleViewClick}
          dateState={dateState}
          extraPrint={true}
          formName={"biltyReport"}
        />
        <div className="form-footer">
          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="bilty_report_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Download as XLS"
              ref={(a) => (download_ref.current = a)}
            />
          </button>
          <button
            className="download-table-xls-button"
            onClick={async () => {
              setLoading(true);
              let dataToSend = {
                date_dict: finalInput.date_dict,
                filter_fields: finalInput.filter_fields,
              };
              let url = SERVER_URL + "/report/";

              if(dateState.report_type == "deleted") {
                  url += "deleted/";
              } else if(dateState.report_type == "inward" || dateState["report_type"] == "admin-inward") {
                  url += "inward";
              }

              let resp = await fetch(url, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(dataToSend),
              });
              let response = await resp.json();

              if (response["data"] && "total_rows" in response) {
                console.log(response["data"], "fsdfafsfds");
                // setData(response["data"]);
                ex_data = response["data"];
                // setPageCount(Math.ceil(response["total_rows"] / pageSize));
              }
              setLoading(false);
              download_ref.current.handleDownload();
            }}
          >
            Download as XLS
          </button>
          {ReportExcel.excel_data(
            { columns },
            { ex_data },
            { fetchData },
            { dateState },
            { loading },
            { pageCount },
            { dateState }
          )}

        </div>
      </div>
    </div>
  );
}

export default BiltyReport;
